const STORAGE_KEY = 'sfre_theme';

let currentTheme = 'light';
let themeChangeCallback = null;

/**
 * Initialize theme from localStorage or system preference
 */
export function initTheme() {
  // Check localStorage first
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored) {
    currentTheme = stored;
  } else if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
    currentTheme = 'dark';
  }

  applyTheme();

  // Listen for system theme changes
  window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', (e) => {
    if (!localStorage.getItem(STORAGE_KEY)) {
      currentTheme = e.matches ? 'dark' : 'light';
      applyTheme();
    }
  });
}

/**
 * Apply the current theme to the document
 */
function applyTheme() {
  document.body.classList.remove('theme-light', 'theme-dark');
  document.body.classList.add(`theme-${currentTheme}`);

  if (themeChangeCallback) {
    themeChangeCallback(currentTheme);
  }
}

/**
 * Get the current theme
 */
export function getCurrentTheme() {
  return currentTheme;
}

/**
 * Toggle between light and dark themes
 */
export function toggleTheme() {
  currentTheme = currentTheme === 'light' ? 'dark' : 'light';
  localStorage.setItem(STORAGE_KEY, currentTheme);
  applyTheme();
}

/**
 * Register a callback for theme changes
 */
export function onThemeChange(callback) {
  themeChangeCallback = callback;
}
